import { render, staticRenderFns } from "./MuralUpcoming.vue?vue&type=template&id=5a22e502&scoped=true"
import script from "./MuralUpcoming.vue?vue&type=script&lang=js"
export * from "./MuralUpcoming.vue?vue&type=script&lang=js"
import style0 from "./MuralUpcoming.vue?vue&type=style&index=0&id=5a22e502&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22e502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a22e502')) {
      api.createRecord('5a22e502', component.options)
    } else {
      api.reload('5a22e502', component.options)
    }
    module.hot.accept("./MuralUpcoming.vue?vue&type=template&id=5a22e502&scoped=true", function () {
      api.rerender('5a22e502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/mural/MuralUpcoming.vue"
export default component.exports